angular.module('admin', [
  'admin.index',
  'admin.users',
  'admin.subscribers',
  'admin.gallery',
  //'admin.politics',
  'admin.groups',
  'admin.diagrams.index',
  'admin.editions.index',
  'admin.recuentos.index',
  'admin.statuses',
  'admin.categories',
  'admin.articles',
  'admin.menus',
  'admin.reindexing',
  'admin.cover.index',
  'admin.homepage'
]);

// require ('./cover/cover.js');



// WEBPACK FOOTER //
// ./client/src/app/admin/index.js